/* ============================================================
   EPAVANCE — Main JavaScript
   Handles: nav, cart, FAQ, announcement bar, buy box
   ============================================================ */

(function () {
  'use strict';

  /* ---- Announcement bar rotation ---- */
  function initAnnouncement() {
    const textEl = document.getElementById('ann-text');
    const iconEl = document.getElementById('ann-icon');
    if (!textEl) return;

    const msgs = [
      { icon: 'truck',         text: 'Free tracked delivery across the UK' },
      { icon: 'stethoscope',   text: 'Reviewed by UK gastroenterologists' },
      { icon: 'shield-check',  text: 'Food for Special Medical Purposes — Pharma-grade manufacture' },
    ];
    let i = 0;

    setInterval(function () {
      i = (i + 1) % msgs.length;
      textEl.textContent = msgs[i].text;
      if (iconEl) {
        iconEl.setAttribute('data-lucide', msgs[i].icon);
        if (window.lucide) lucide.createIcons({ nodes: [iconEl] });
      }
    }, 4200);
  }

  /* ---- Header scroll behaviour ---- */
  function initHeaderScroll() {
    const header = document.querySelector('.site-header');
    if (!header) return;
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  /* ---- Mega menu ---- */
  function initMegaMenu() {
    const nav = document.querySelector('.header-nav');
    const mega = document.querySelector('.mega-menu');
    if (!nav || !mega) return;

    const items = nav.querySelectorAll('.nav-item[data-panel]');
    const panels = mega.querySelectorAll('.mega-panel');
    const header = document.querySelector('.site-header');

    function openPanel(id) {
      panels.forEach(function (p) { p.hidden = p.dataset.panel !== id; });
      items.forEach(function (it) { it.classList.toggle('active', it.dataset.panel === id); });
      mega.classList.add('open');
      if (header) header.classList.add('menu-open');
    }

    function closeAll() {
      mega.classList.remove('open');
      if (header) header.classList.remove('menu-open');
      items.forEach(function (it) { it.classList.remove('active'); });
    }

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () { openPanel(item.dataset.panel); });
    });

    header && header.addEventListener('mouseleave', closeAll);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  }

  /* ---- Mobile nav ---- */
  function initMobileNav() {
    const toggle = document.querySelector('.mobile-nav-toggle');
    const drawer = document.querySelector('.mobile-nav-drawer');
    if (!toggle || !drawer) return;

    toggle.addEventListener('click', function () {
      const isOpen = drawer.classList.toggle('open');
      toggle.setAttribute('aria-expanded', isOpen);
    });
  }

  /* ---- FAQ accordion ---- */
  function initFAQ() {
    document.querySelectorAll('.faq-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const isOpen = btn.getAttribute('aria-expanded') === 'true';
        const answer = document.getElementById(btn.getAttribute('aria-controls'));

        // Close all
        document.querySelectorAll('.faq-toggle').forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          const a = document.getElementById(b.getAttribute('aria-controls'));
          if (a) a.classList.remove('open');
          // reset icon
          const icon = b.querySelector('.faq-icon-plus');
          const iconMinus = b.querySelector('.faq-icon-minus');
          if (icon) icon.style.display = '';
          if (iconMinus) iconMinus.style.display = 'none';
        });

        if (!isOpen && answer) {
          btn.setAttribute('aria-expanded', 'true');
          answer.classList.add('open');
          const icon = btn.querySelector('.faq-icon-plus');
          const iconMinus = btn.querySelector('.faq-icon-minus');
          if (icon) icon.style.display = 'none';
          if (iconMinus) iconMinus.style.display = '';
        }
      });
    });
  }

  /* ---- Cart state ---- */
  var cart = {
    items: [],
    listeners: [],

    add: function (name, variant, price) {
      var existing = this.items.find(function (i) { return i.variant === variant; });
      if (existing) {
        existing.qty += 1;
      } else {
        this.items.push({ id: Date.now(), name: name, variant: variant, price: price, qty: 1 });
      }
      this._notify();
    },

    remove: function (id) {
      this.items = this.items.filter(function (i) { return i.id !== id; });
      this._notify();
    },

    setQty: function (id, qty) {
      var item = this.items.find(function (i) { return i.id === id; });
      if (item) item.qty = Math.max(1, qty);
      this._notify();
    },

    total: function () {
      return this.items.reduce(function (s, i) { return s + i.price * i.qty; }, 0);
    },

    count: function () {
      return this.items.reduce(function (s, i) { return s + i.qty; }, 0);
    },

    onChange: function (fn) { this.listeners.push(fn); },

    _notify: function () {
      var self = this;
      this.listeners.forEach(function (fn) { fn(self); });
    }
  };

  /* ---- Cart drawer render ---- */
  function renderCartItems() {
    var el = document.getElementById('cart-items');
    if (!el) return;

    if (cart.items.length === 0) {
      el.innerHTML = '<div class="cart-empty">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>' +
        '<p>Your basket is empty.</p>' +
        '</div>';
      return;
    }

    el.innerHTML = cart.items.map(function (item) {
      return '<div class="cart-item" data-id="' + item.id + '">' +
        '<div class="cart-item-img"><img src="../design/assets/packaging/epavance-box-front.png" alt=""></div>' +
        '<div class="cart-item-body">' +
          '<div class="cart-item-top">' +
            '<div>' +
              '<div class="cart-item-name">' + item.name + '</div>' +
              '<div class="cart-item-variant">' + item.variant + '</div>' +
            '</div>' +
            '<button class="cart-item-remove" data-remove="' + item.id + '" aria-label="Remove">' +
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="cart-item-bottom">' +
            '<div class="cart-qty-control">' +
              '<button class="cart-qty-btn" data-qty-minus="' + item.id + '">' +
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
              '</button>' +
              '<span class="cart-qty-num">' + item.qty + '</span>' +
              '<button class="cart-qty-btn" data-qty-plus="' + item.id + '">' +
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
              '</button>' +
            '</div>' +
            '<div class="cart-item-price">£' + (item.price * item.qty).toFixed(2) + '</div>' +
          '</div>' +
        '</div>' +
        '</div>';
    }).join('');

    // Bind remove / qty buttons
    el.querySelectorAll('[data-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () { cart.remove(parseInt(btn.dataset.remove)); });
    });
    el.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = parseInt(btn.dataset.qtyMinus);
        var item = cart.items.find(function (i) { return i.id === id; });
        if (item) cart.setQty(id, item.qty - 1);
      });
    });
    el.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = parseInt(btn.dataset.qtyPlus);
        var item = cart.items.find(function (i) { return i.id === id; });
        if (item) cart.setQty(id, item.qty + 1);
      });
    });
  }

  function updateCartUI() {
    renderCartItems();

    // Totals
    var subtotalEl = document.getElementById('cart-subtotal');
    var checkoutBtn = document.getElementById('cart-checkout-btn');
    var countEl = document.getElementById('cart-count');
    var titleEl = document.getElementById('cart-title');

    if (subtotalEl) subtotalEl.textContent = '£' + cart.total().toFixed(2);
    if (checkoutBtn) checkoutBtn.textContent = 'Checkout — £' + cart.total().toFixed(2);
    if (countEl) {
      countEl.textContent = cart.count();
      countEl.style.display = cart.count() > 0 ? '' : 'none';
    }
    if (titleEl) titleEl.textContent = 'Your basket (' + cart.items.length + ')';
  }

  /* ---- Cart drawer open/close ---- */
  function initCart() {
    var drawer = document.getElementById('cart-drawer');
    var overlay = document.getElementById('cart-overlay');
    var openBtns = document.querySelectorAll('[data-cart-open]');
    var closeBtn = document.getElementById('cart-close');

    function open() {
      if (drawer) drawer.classList.add('open');
      if (overlay) overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      if (drawer) drawer.classList.remove('open');
      if (overlay) overlay.classList.remove('open');
      document.body.style.overflow = '';
    }

    openBtns.forEach(function (btn) { btn.addEventListener('click', open); });
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);

    cart.onChange(updateCartUI);
    updateCartUI();

    return { open: open, close: close };
  }

  /* ---- Buy box ---- */
  function initBuyBox() {
    var options = document.querySelectorAll('.purchase-option');
    var addBtn  = document.getElementById('add-to-basket');

    if (!addBtn) return;

    function getSelected() {
      for (var i = 0; i < options.length; i++) {
        var radio = options[i].querySelector('input[type="radio"]');
        if (radio && radio.checked) return options[i];
      }
      return options[0];
    }

    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        options.forEach(function (o) {
          o.classList.remove('selected');
          var r = o.querySelector('input[type="radio"]');
          if (r) r.checked = false;
        });
        opt.classList.add('selected');
        var radio = opt.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;

        var price = opt.dataset.price;
        var variant = opt.dataset.variant;
        if (addBtn) addBtn.textContent = 'Add to basket — £' + parseFloat(price).toFixed(2);
      });
    });

    addBtn.addEventListener('click', function () {
      var selected = getSelected();
      var price   = parseFloat(selected.dataset.price || '39');
      var variant = selected.dataset.variant || 'One‑time purchase';
      cart.add('EPAVANCE 60ct', variant, price);

      // Open cart
      var cartDrawer = document.getElementById('cart-drawer');
      var overlay    = document.getElementById('cart-overlay');
      if (cartDrawer) cartDrawer.classList.add('open');
      if (overlay)    overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    });

    // Gallery thumbnails
    var thumbs = document.querySelectorAll('.buy-box-thumb');
    var mainImg = document.getElementById('main-product-img');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        if (mainImg) {
          mainImg.src = thumb.dataset.src;
        }
      });
    });
  }

  /* ---- Final CTA scroll-to-shop ---- */
  function initCTALinks() {
    document.querySelectorAll('[data-scroll-to]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById(el.dataset.scrollTo);
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ---- Lucide icons init ---- */
  function initIcons() {
    if (window.lucide) {
      lucide.createIcons();
      setTimeout(function () { lucide.createIcons(); }, 300);
    }
  }

  /* ---- Init all ---- */
  document.addEventListener('DOMContentLoaded', function () {
    initAnnouncement();
    initHeaderScroll();
    initMegaMenu();
    initMobileNav();
    initFAQ();
    initCart();
    initBuyBox();
    initCTALinks();
    initIcons();
  });

  // Expose cart globally for page-specific scripts
  window.epavanceCart = cart;

})();
